<template>
	<div>
		<select multiple v-model="selectedPlayers">
			<option
				v-for="(player, index) in orderedPlayers"
				:value="player.id"
				:key="player.id">
				{{player.name}}
			</option>
		</select>
		<input type="" name="" disabled :value="selectedPlayers">
	</div>
</template>

<script>
	export default {
		name: 'player',
		data () {
			return {
				players: [],
				selectedPlayers: []
			}
		},
		methods: {
			getData: function(endpoint, callback) {
				let self = this;
				var xhr = new XMLHttpRequest();
				xhr.open('GET', endpoint, true);
				xhr.send(null);

				xhr.onreadystatechange = function () {
					var
					DONE = 4,
					OK = 200;
						
					if (xhr.readyState === DONE) {
						if (xhr.status === OK) {
							let jsonResponse = JSON.parse(xhr.responseText)
							callback(jsonResponse);
						} else {
							console.log('Error: ' + xhr.status)
						}
					}
				}
			},
			compare: function(a,b) {
				if (a.name < b.name) {
					return - 1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			}
		},
		mounted: function () {
			let self = this;
			this.getData('https://api.ffa.football/sync/players', function(callback){
				self.players = callback;
				//self.selectedPlayers.push(callback[0].id);
			});
		},
		computed: {
			orderedPlayers: function() {
				return this.players.sort(this.compare);
			}
		},
		watch: {
			selectedPlayers: function() {
				let self = this;
				this.$emit('playerUpdated', self.selectedPlayers);
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Player.vue?e9f92d60